// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.k-form .dataCaptureSection .addAdditionalName {
  font-size: 15px;
  text-align: left;
  padding-left: 32px;
  padding-right: 32px;
}
.k-form .dataCaptureSection .addAdditionalName div {
  text-align: center;
}
.k-form .dataCaptureSection .sectionContainer.addAdditionalName.expanded {
  padding-left: 17px;
  padding-right: 17px;
}
@media (max-width: 599px) {
  .k-form .dataCaptureSection .sectionContainer.addAdditionalName.expanded {
    padding-left: 0;
    padding-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/AdditionalNamesEditor.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAWF;AAhBA;EAOG,kBAAA;AAYH;AAnBA;EAYE,kBAAA;EACA,mBAAA;AAUF;AAPC;EAEE;IACC,eAAA;IACA,gBAAA;EAQF;AACF","sourcesContent":["@import '../../constants.less';\n\n.k-form .dataCaptureSection {\n\t.addAdditionalName {\n\t\tfont-size: 15px;\n\t\ttext-align: left;\n\t\tpadding-left: 32px;\n\t\tpadding-right: 32px;\n\t\tdiv {\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t.sectionContainer.addAdditionalName.expanded {\n\t\tpadding-left: @dataCaptureContainerPadding;\n\t\tpadding-right: @dataCaptureContainerPadding;\n\t}\n\n\t@media (max-width: @phoneOnlyMaxWidth) {\n\t\t.sectionContainer.addAdditionalName {\n\t\t\t&.expanded {\n\t\t\t\tpadding-left: 0;\n\t\t\t\tpadding-right: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
